import { BORDER } from '../../../constants/Border';
import { COLORS } from '../../../constants/Colors';
import { FONTS } from '../../../constants/Fonts';
import { SIZES } from '../../../constants/Sizes';
import { SPACING } from '../../../constants/Spacing';

const MOBILE = '@media (max-width: 768px)';

export const SX_STYLES = {
    navigationContainer: {
        display: 'flex',
        position: 'fixed',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: '2vh',
        paddingBottom: '2vh',
        width: '100vw',
        backgroundColor: COLORS.lightBlueA1,
        zIndex: 99
    },
    navigationWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: SPACING._32px,
    },
    logoContainer: {
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        marginLeft: SPACING.x_large,
        marginRight: SPACING._22px,
        cursor: 'pointer',
        [MOBILE]: {
            marginLeft: '4vw',
        },
    },
    logoStyle: {
        height: '4.2vh',
        marginRight: SPACING._6px
    },
    logoName: {
        ...FONTS.font600,
        fontSize: SIZES._16px,
        color: COLORS.blueD66,
    },
    desktopLinks: {
        display: 'flex',
        alignItems: 'center',
        gap: SPACING._32px,
        [MOBILE]: { display: 'none' },
    },
    desktopContact: {
        [MOBILE]: { display: 'none' },
    },
    hamburger: {
        display: 'none',
        marginRight: '3vw',
        [MOBILE]: { display: 'flex' },
    },
    drawerContainer: {
        width: '70vw',
        display: 'flex',
        flexDirection: 'column',
        padding: '2vh 3vw',
        height: '100%',
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: '2vh',
        borderBottom: `1px solid ${COLORS.grayEA}`,
        marginBottom: '1vh',
    },
    drawerLinkText: {
        ...FONTS.font400,
        fontSize: '16px',
        color: COLORS.blueD66,
    },
    drawerContactBtn: {
        marginTop: 'auto',
        paddingTop: '3vh',
    },
    buttonContact: {
        ...FONTS.font500,
        fontSize: SIZES._16px,
        color: COLORS.white,
        backgroundColor: COLORS.blueE7,
        textTransform:'none',
        paddingTop: SPACING._10px,
        paddingBottom: SPACING._10px,
        paddingRight: SPACING._18px,
        paddingLeft: SPACING._18px,
        borderRadius: BORDER._8px,
        marginRight: '14.2vw',
        transition: 'transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease',
        '&:hover': {
            backgroundColor: COLORS.blueD4,
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px rgba(41,97,231,0.28)',
        },
        '&:active': {
            transform: 'translateY(0px)',
        },
    },
}